import { getUser } from "@/actions/auth";
import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import { useDispatch, useSelector } from "react-redux";

export const useFetchUserData = (options: UseQueryOptions = {}) => {
	const dispatch = useDispatch();
	const user = useSelector((state) => (state as any).auth?.user);
	const userQuery = useQuery({
		enabled: Boolean(user),
		queryKey: ["user"],
		queryFn: async () => {
			const result = await dispatch(getUser() as any)
			return result
		},
		...options,
	});

	return userQuery
};